import { render, staticRenderFns } from "./modalAddNewTermsAndConditions.vue?vue&type=template&id=791e929f&"
import script from "./modalAddNewTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./modalAddNewTermsAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports